import clsx from 'clsx';
import React from 'react';
import styles from './CardContent.module.scss';

interface CardContentProps {
    className?: string;
    children?: React.ReactNode;
}

export const CardContent: React.FC<CardContentProps> = ({ className, children }) => {
    return (
        <div data-slot="content" className={clsx(styles.root, className)}>
            {children}
        </div>
    );
};
